/* MEATBROS · thème Shopify · scripts (vanilla, sans dépendance) */
(function () {
  'use strict';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html, delay) {
    var el = $('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('visible'); }, delay || 4000);
  }
  window.meatbrosToast = toast;

  /* ---------- Menu mobile ---------- */
  var menu = $('#MenuMobile');
  function openMenu() { if (!menu) return; menu.classList.add('ouvert'); menu.setAttribute('aria-hidden', 'false'); document.body.classList.add('menu-ouvert'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { if (!menu) return; menu.classList.remove('ouvert'); menu.setAttribute('aria-hidden', 'true'); document.body.classList.remove('menu-ouvert'); document.body.style.overflow = ''; }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  /* ---------- Recherche ---------- */
  var search = $('#Recherche');
  function openSearch() { if (!search) return; search.classList.add('ouvert'); search.setAttribute('aria-hidden', 'false'); var i = $('input[type="search"]', search); if (i) setTimeout(function () { i.focus(); }, 50); }
  function closeSearch() { if (!search) return; search.classList.remove('ouvert'); search.setAttribute('aria-hidden', 'true'); }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  if (search) search.addEventListener('click', function (e) { if (e.target === search) closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeMenu(); $$('details[data-sous-menu][open]').forEach(function (d) { d.removeAttribute('open'); }); } });

  /* ---------- Sous-menus desktop (details) ---------- */
  var sousMenus = $$('details[data-sous-menu]');
  sousMenus.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) sousMenus.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
    d.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) d.removeAttribute('open'); });
  });
  document.addEventListener('click', function (e) {
    sousMenus.forEach(function (d) { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Header : ombre au scroll ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Rails (carrousels horizontaux) ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var track = $('[data-rail-track]', rail);
    if (!track) return;
    var step = function () { var first = track.firstElementChild; return first ? first.getBoundingClientRect().width + 20 : 300; };
    var prev = $('[data-rail-prev]', rail), next = $('[data-rail-next]', rail);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* ---------- Avis clients ---------- */
  $$('[data-avis]').forEach(function (box) {
    var items = $$('.avis__item', box); if (items.length < 2) return;
    var idx = 0, out = $('[data-avis-index]', box), timer;
    function show(i) { idx = (i + items.length) % items.length; items.forEach(function (it, k) { it.classList.toggle('actif', k === idx); }); if (out) out.textContent = idx + 1; }
    function auto() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, 7000); }
    var p = $('[data-avis-prev]', box), n = $('[data-avis-next]', box);
    if (p) p.addEventListener('click', function () { show(idx - 1); auto(); });
    if (n) n.addEventListener('click', function () { show(idx + 1); auto(); });
    auto();
  });

  /* ---------- Panier : compteur ---------- */
  function refreshCartCount() {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    }).catch(function () {});
  }

  /* ---------- Utilitaires e-shop : échappement et format de prix ---------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  /* Reprend le format monétaire de la boutique (window.meatbrosMoneyFormat), séparateurs de milliers compris */
  function formatMoney(cents) {
    var fmt = window.meatbrosMoneyFormat || '{{amount_with_comma_separator}} €';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = m ? m[1] : 'amount_with_comma_separator';
    var num = function (dec, mil, sep) {
      var parts = (Math.round(cents) / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return parts[0] + (parts[1] ? sep + parts[1] : '');
    };
    var val;
    switch (type) {
      case 'amount_no_decimals': val = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': val = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = num(2, '\'', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = num(0, ' ', ','); break;
      case 'amount_with_space_separator': val = num(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': val = num(2, ' ', '.'); break;
      default: val = num(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  /* ---------- Ajout au panier (AJAX) ---------- */
  function ajaxAdd(form, btn) {
    var fd = new FormData(form);
    var label = btn ? btn.innerHTML : '';
    var compact = btn ? btn.classList.contains('pc__ajout') : false;
    var restore = function () {
      if (btn) { btn.innerHTML = label; btn.classList.remove('ajoute'); btn.disabled = false; }
      form.dispatchEvent(new CustomEvent('meatbros:ajout-fini', { bubbles: true }));
    };
    if (btn) { btn.disabled = true; btn.classList.add('ajoute'); btn.innerHTML = '…'; }
    return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.json && (res.json.description || res.json.message) || 'Erreur'); }
        var j = res.json;
        var title = j.product_title || j.title || 'Produit';
        if (j.variant_title && j.product_has_only_default_variant === false) title += ' (' + j.variant_title + ')';
        toast('<span>' + esc(title) + ' ajouté au panier.</span><a href="' + root + 'cart">Voir le panier →</a>', 5000);
        refreshCartCount();
        if (btn) {
          btn.innerHTML = compact ? '<span class="pc__ajout-txt">Ajouté</span> <span class="fl">✓</span>' : 'Ajouté ✓';
          setTimeout(restore, 1600);
        } else { restore(); }
      })
      .catch(function (err) {
        toast('<span>' + esc(err.message || 'Impossible d’ajouter ce produit.') + '</span>', 5000);
        restore();
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-ajax-add], [data-product-form]')) {
      e.preventDefault();
      ajaxAdd(form, $('button[type="submit"]', form));
    }
  });

  /* ---------- Fiche produit : variantes, quantité, total du bouton, miniatures ---------- */
  $$('[data-product]').forEach(function (box) {
    var form = $('[data-product-form]', box);
    var qtyInput = form ? $('input[name="quantity"]', form) : null;
    var idInput = $('[data-variant-id]', box);
    var btn = $('[data-add-to-cart]', box);
    var dataEl = $('[data-variants]', box);
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }
    var labels = {
      long: (btn && btn.getAttribute('data-label-long')) || 'Ajouter au panier',
      court: (btn && btn.getAttribute('data-label-court')) || 'Ajouter',
      epuise: (btn && btn.getAttribute('data-label-epuise')) || 'Épuisé',
      indispo: (btn && btn.getAttribute('data-label-indispo')) || 'Indisponible'
    };
    function qty() { var q = parseInt(qtyInput ? qtyInput.value : 1, 10); return isNaN(q) || q < 1 ? 1 : q; }
    function variantById(id) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }
    function variantFromOptions() {
      var chosen = $$('[data-option]:checked', box).map(function (r) { return r.value; });
      if (!chosen.length) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < chosen.length; k++) { if (v.options[k] !== chosen[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    var combinaisonInexistante = false;
    function currentVariant() { return (idInput && variantById(idInput.value)) || variants[0] || null; }
    /* Libellé du bouton : version longue (ordinateur) et courte (mobile), prix × quantité */
    function refreshButton() {
      if (!btn || btn.classList.contains('ajoute')) return;
      if (combinaisonInexistante) { btn.disabled = true; btn.textContent = labels.indispo; return; }
      var v = currentVariant();
      if (!v) return;
      if (!v.available) { btn.disabled = true; btn.textContent = labels.epuise; return; }
      btn.disabled = false;
      btn.innerHTML = '<span class="mb-ajout__long">' + esc(labels.long) + '</span><span class="mb-ajout__court">' + esc(labels.court) + '</span> <span class="fl">·</span> <span data-add-price>' + formatMoney(v.price * qty()) + '</span>';
    }
    function updateVariant() {
      var v = variantFromOptions();
      combinaisonInexistante = !v;
      if (!v) { refreshButton(); return; }
      if (idInput) idInput.value = v.id;
      var price = $('[data-product-price]', box); if (price) price.innerHTML = formatMoney(v.price);
      var unit = $('[data-unit-price]', box); if (unit) { unit.textContent = v.unite || ''; unit.hidden = !v.unite; }
      refreshButton();
      if (v.image) { var img = $('[data-product-main-image]', box); if (img) { img.removeAttribute('srcset'); img.src = v.image; } }
      if (window.history && window.history.replaceState) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
    }
    if (qtyInput) {
      var minus = $('[data-qty-minus]', box), plus = $('[data-qty-plus]', box);
      var qMin = function () { return parseInt(qtyInput.min || 1, 10) || 1; };
      if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(qMin(), qty() - 1); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); });
      if (plus) plus.addEventListener('click', function () { qtyInput.value = qty() + 1; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); });
      qtyInput.addEventListener('input', refreshButton);
      qtyInput.addEventListener('change', function () { if (String(qty()) !== qtyInput.value) qtyInput.value = qty(); refreshButton(); });
    }
    if (form) form.addEventListener('meatbros:ajout-fini', refreshButton);
    window.addEventListener('pageshow', refreshButton);
    refreshButton();
    $$('[data-option]', box).forEach(function (r) { r.addEventListener('change', updateVariant); });
    $$('[data-thumb]', box).forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('[data-product-main-image]', box); if (!img) return;
        img.removeAttribute('srcset'); img.src = t.getAttribute('data-thumb');
        $$('[data-thumb]', box).forEach(function (o) { o.classList.remove('actif'); }); t.classList.add('actif');
      });
    });
  });

  /* ---------- Panier : lignes ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var submitCart = function () { cartForm.querySelectorAll('button[name="checkout"]').forEach(function (b) { b.disabled = true; }); cartForm.submit(); };
    $$('[data-line]', cartForm).forEach(function (line) {
      var qty = $('[data-line-qty]', line);
      var m = $('[data-line-minus]', line), p = $('[data-line-plus]', line);
      if (m) m.addEventListener('click', function () { qty.value = Math.max(0, (parseInt(qty.value, 10) || 0) - 1); submitCart(); });
      if (p) p.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 0) + 1; submitCart(); });
      if (qty) qty.addEventListener('change', submitCart);
    });
    var note = $('#CartNote', cartForm);
    if (note) {
      var noteTimer;
      note.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(function () {});
        }, 600);
      });
    }
  }

  /* ---------- Collection : tri ---------- */
  $$('[data-sort-form] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Collection : rayon actif visible dans la ligne défilante (mobile) ---------- */
  $$('[data-rayons]').forEach(function (nav) {
    var actif = $('.actif', nav);
    if (actif && nav.scrollWidth > nav.clientWidth) {
      nav.scrollLeft = Math.max(0, actif.offsetLeft - (nav.clientWidth - actif.offsetWidth) / 2);
    }
  });

  /* ---------- Recommandations produit ----------
     Le rendu initial affiche des produits du même rayon ; on ne les remplace que si Shopify renvoie des cartes. */
  $$('[data-recommendations]').forEach(function (sec) {
    var url = sec.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.pc')) { sec.innerHTML = fresh.innerHTML; sec.classList.remove('mb-recos--vide'); }
    }).catch(function () {});
  });

  /* ---------- Compte : adresses ---------- */
  $$('[data-address-edit]').forEach(function (b) {
    b.addEventListener('click', function () { var box = document.getElementById('AddressEdit-' + b.getAttribute('data-address-edit')); if (box) box.hidden = !box.hidden; });
  });
  $$('[data-address-delete]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (!window.confirm('Supprimer cette adresse ?')) return;
      var f = document.createElement('form'); f.method = 'post'; f.action = b.getAttribute('data-url');
      var i = document.createElement('input'); i.type = 'hidden'; i.name = '_method'; i.value = 'delete'; f.appendChild(i);
      document.body.appendChild(f); f.submit();
    });
  });
  $$('select[data-default]').forEach(function (sel) {
    var d = sel.getAttribute('data-default'); if (!d) return;
    $$('option', sel).forEach(function (o) { if (o.value === d || o.textContent === d) o.selected = true; });
  });
  $$('[data-recover-open]').forEach(function (a) { a.addEventListener('click', function () { var r = $('#recover'); if (r) { r.hidden = false; r.scrollIntoView({ behavior: 'smooth' }); } }); });

  /* ---------- Formulaires : scroll vers le message de succès ---------- */
  var success = $('.form-success');
  if (success && window.location.hash.indexOf('contact_form') > -1) { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }

  refreshCartCount();
})();
